module.exports = __webpack_public_path__ + "img/chinesecompany06.34c7adb4.png";